"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ImageStylesMaps_1 = require("./ImageStylesMaps");
var react_lazyload_1 = require("react-lazyload");
var react_lazyload_2 = require("react-lazyload");
var Image = /** @class */ (function (_super) {
    __extends(Image, _super);
    function Image(props) {
        var _this = _super.call(this, props) || this;
        _this.onImageClick = _this.onImageClick.bind(_this);
        return _this;
    }
    Image.prototype.componentDidMount = function () {
        if (this.props.lazyLoadOptions && this.props.lazyLoadOptions.forceCheck) {
            react_lazyload_2.forceCheck();
        }
    };
    Image.prototype.render = function () {
        var lazyLoadRender = this.props.lazyLoad ? this.props.lazyLoad : false;
        var imgHeight = '100%';
        var cls = [
            this.getTypeFromOps(this.props.options),
            this.props.options.className,
        ];
        return (React.createElement(React.Fragment, null,
            lazyLoadRender &&
                React.createElement(react_lazyload_1.default, { height: this.props.lazyLoadOptions &&
                        this.props.lazyLoadOptions.height ? this.props.lazyLoadOptions.height : imgHeight, offset: this.props.lazyLoadOptions &&
                        this.props.lazyLoadOptions.offset ? this.props.lazyLoadOptions.offset : 200, throttle: this.props.lazyLoadOptions &&
                        this.props.lazyLoadOptions.throttle ? this.props.lazyLoadOptions.throttle : 200, once: this.props.lazyLoadOptions &&
                        this.props.lazyLoadOptions.once ? this.props.lazyLoadOptions.once : false, scroll: this.props.lazyLoadOptions &&
                        this.props.lazyLoadOptions.scroll ? this.props.lazyLoadOptions.scroll : true, resize: this.props.lazyLoadOptions &&
                        this.props.lazyLoadOptions.resize ? this.props.lazyLoadOptions.resize : false, unmountIfInvisible: this.props.lazyLoadOptions &&
                        this.props.lazyLoadOptions.unmountIfInvisible ?
                        this.props.lazyLoadOptions.unmountIfInvisible : false, overflow: this.props.lazyLoadOptions &&
                        this.props.lazyLoadOptions.overflow ? this.props.lazyLoadOptions.overflow : false },
                    React.createElement("img", { "data-test-id": this.props.testId, className: cls.join(' '), onClick: this.props.events && this.props.events.onClick ? this.onImageClick : null, src: this.props.data.url, alt: this.props.options.alt, height: this.props.options.height, width: this.props.options.width, "aria-label": this.props.options.alt, role: "img" })),
            !lazyLoadRender &&
                React.createElement("img", { "data-test-id": this.props.testId, className: cls.join(' '), onClick: this.props.events && this.props.events.onClick ? this.onImageClick : null, src: this.props.data.url, alt: this.props.options.alt, height: this.props.options.height, width: this.props.options.width, "aria-label": this.props.options.alt, role: "img" })));
    };
    Image.prototype.getTypeFromOps = function (options) {
        if (options && options.type) {
            return ImageStylesMaps_1.stylesMap.get(options.type);
        }
        return null;
    };
    Image.prototype.onImageClick = function (e) {
        return this.props.events ? this.props.events.onClick() : null;
    };
    Image.defaultProps = {
        options: {},
    };
    return Image;
}(React.Component));
exports.default = Image;
//# sourceMappingURL=Image.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Image/Image.js
// module id = 1152
// module chunks = 8